import { render, staticRenderFns } from "./referral-info.vue?vue&type=template&id=c9937f34&scoped=true&"
import script from "./referral-info.vue?vue&type=script&lang=js&"
export * from "./referral-info.vue?vue&type=script&lang=js&"
import style0 from "./referral-info.vue?vue&type=style&index=0&id=c9937f34&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9937f34",
  null
  
)

export default component.exports